<template>
  <div id="student-work" class="student-work">
    <student-work-item
      v-for="(work, index) in displayedWork"
      :key="index"
      :work="work"
      @open-student-work-modal="showModal"
      @mouseover.native="stopTimer"
      @focusin.native="stopTimer"
      @focusout.native="resetFocus"
    />

    <transition name="fade">
      <student-work-modal
        v-if="selectedWork"
        :is-visible="modalVisible"
        :work="selectedWork"
        @close-student-work-modal="hideModal"
      />
    </transition>
  </div>
</template>

<script>
import StudentWorkItem from './StudentWorkItem.vue'
import StudentWorkModal from './StudentWorkModal.vue'

const API_URL = '/api/student-work'
const PROJECT_COUNT = 6
const REFRESH_RATE = 6000

export default {
  name: 'StudentWork',

  components: {
    StudentWorkItem,
    StudentWorkModal
  },

  data () {
    return {
      displayedWork: [],
      displayedWorkCount: 0,
      modalVisible: false,
      ready: false,
      selectedWork: null,
      work: null
    }
  },

  mounted () {
    this.getStudentWork()
  },

  destroyed () {
    if (this.timer) { clearInterval(this.timer) }
  },

  methods: {
    /**
     * Fetches data from the student work API endpoint
     * Stashes the array of work
     * Calls the setStartingWork() method and sets the component to ready
     */
    getStudentWork () {
      fetch(API_URL).then(response => {
        return response.json()
      }).then(json => {
        this.ready = true
        this.work = json.data
        this.setStartingWork()
      }).catch(error => {
        console.log(error)
      })
    },

    /**
     * Sets up the initial work to display based on PROJECT_COUNT
     * Sets a timer to begin randomly updating work based on REFRESH_RATE
     */
    setStartingWork () {
      this.displayedWork = this.work.slice(0, PROJECT_COUNT)
      this.displayedWorkCount = PROJECT_COUNT
      this.timer = setInterval(this.randomlyUpdateWork, REFRESH_RATE)
    },

    /**
     * Selects a random index value from the array of currently displayed work.
     * Duplicates this array and replaces the randomly-selected item with the
     * next item from the larger work array. Then replaces the displayedWork
     * array with this new modified copy to force a re-render of child
     * components. Increments a counter so that the next item can be grabbed
     * when this method is called again. Resets the counter if all work has been
     * shown already so that the updates loop forever.
     */
    randomlyUpdateWork () {
      if (this.displayedWorkCount >= this.work.length) { this.displayedWorkCount = 0 }

      let randomIndex = Math.floor(Math.random() * PROJECT_COUNT)
      let newWorkToDisplay = [...this.displayedWork]
      newWorkToDisplay[randomIndex] = this.work[this.displayedWorkCount]

      this.displayedWork = newWorkToDisplay
      this.displayedWorkCount++
    },

    /**
     * Opens the modal lightbox with the selected work object displayed.
     * Also stops the timer in the background, so that the tiles do not change
     * while the modal is open.
     *
     * @param {Object} work
     */
    showModal (work) {
      this.stopTimer();
      this.selectedWork = work
      this.modalVisible = true
    },

    /**
     * Closes the modal lightbox. Also re-starts the timer to randomly
     * swap out student work tiles.
     */
    hideModal () {
      this.resetTimer();
      this.modalVisible = false
      this.selectedWork = null
    },
  
    /**
     * Stop timer
     */
    stopTimer () {
      if (this.timer) {clearInterval(this.timer)}
    },
  
    /**
     * Re-start timer to randomly
     */
    resetTimer () {
      this.timer = setInterval(this.randomlyUpdateWork, REFRESH_RATE)
    },
  
    resetFocus(e) {
      if(e.relatedTarget && e.relatedTarget.id !== 'global-modal' && e.relatedTarget.offsetParent.id !== 'student-work') {
        this.resetTimer();
      }
    }
  }
}

</script>
